import React, { Fragment, useContext } from 'react'

import { With2Tabs } from "../../components/With2Tabs"
import { Slide_EchangeTokens_Achat } from "./Slide_EchangeTokens_Achat.js"
import { Slide_EchangeTokens_Vente } from "./Slide_EchangeTokens_Vente.js"
import { Slide_EchangeTokens_Temp } from './Slide_EchangeTokens_Temp.js'
import CoinHeader from '../../components/CoinHeader.js'
import { UserContext } from '../../Contexts/UserContext/UserContext.js'
import useLog from '../../hooks/useLog.js'
import { Slide } from "../../display_wallet.js"
import { ButtonPrimaryOutlined } from '../../components/Buttons.js'


// for now we return a temporary slide directing users to a telegram channel

const url = "https://academiebitcoin.fr/comment-acheter-du-bitcoinsv-bsv-en-ligne-en-europe/"

export function Slide_EchangeTokens_QR(props) {
	const userContext = useContext(UserContext)
	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	const function_id = "Slide_EchangeTokens_QR(" + coinProps.name + "): "
	const log = useLog(function_id)
	log("coinProps.tokenid=", coinProps.tokenid)

	let content_jsx = null
	if (coinProps.tokenid === 'bsv') {
		content_jsx = <a href={url} target="_blank">
			<ButtonPrimaryOutlined>
				Buy or Sell BSV &nbsp;&nbsp;
				<i className="fa fa-external-link" />
			</ButtonPrimaryOutlined>
		</a>

		// content_jsx = <a
		// 	href="https://academiebitcoin.fr/comment-acheter-du-bitcoinsv-bsv-en-ligne-en-europe/"
		// 	target="_blank">
		// 	Acheter ou vendre des BSV 🔗
		// </ a>
	}
	else {
		content_jsx = <Slide_EchangeTokens_Temp />
	}

	return (
		<Slide num={props.num}>
			<center>
				<CoinHeader />
				<br />
				{content_jsx}
			</center>
			<br /><br />
		</Slide>
	)
}

// TODO reactivate this once it works with USDT
export function Slide_EchangeTokens_SwapBot(props) {
	const userContext = useContext(UserContext)
	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	const function_id = "Slide_Send_Tokens(" + coinProps.name + "): "
	const log = useLog(function_id)
	log("coinProps.tokenid=", coinProps.tokenid)

	var jsx_1 = <Fragment>
		<CoinHeader />
		<Slide_EchangeTokens_Achat {...props} />
	</Fragment>

	var jsx_2 = <Fragment>
		<CoinHeader />
		<Slide_EchangeTokens_Vente {...props} />
	</Fragment>

	return (
		<Slide num={props.num} style={{ paddingTop: "0px", overflowX: "hidden" }}>
			<With2Tabs
				startingtab="1"

				title_tab1={"Buy " + coinProps.name}
				title_tab2={"Sell " + coinProps.name}

				content_tab1={jsx_1}
				content_tab2={jsx_2}
			/>
		</Slide>
	)
}
